import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enLogin from './locales/en/login.json';
import enProfile from './locales/en/profile.json';
import enHome from './locales/en/home.json';
import enDashboard from './locales/en/dashboard.json';
import enTimeline from './locales/en/timeline.json';
import enCreateOrg from './locales/en/createOrganization.json';
import enContributions from './locales/en/contributions.json';
import enContributionForm from './locales/en/contributionForm.json';
import enTransactions from './locales/en/transactions.json';
import enAddExpense from './locales/en/addExpense.json';
import enExpenses from './locales/en/expenses.json';
import enApproveExpense from './locales/en/approveExpense.json';
import enDeleteTransaction from './locales/en/deleteTransaction.json';
import enViewExpenses from './locales/en/viewExpenses.json';
import enNotifications from './locales/en/notifications.json';
import enReports from './locales/en/reports.json';
import enDashboards from './locales/en/dashboards.json';
import enAdmin from './locales/en/admin.json';
import enAddUser from './locales/en/addUser.json';
import enUserList from './locales/en/userList.json';
import enBankDetails from './locales/en/bankDetails.json';
import enBankList from './locales/en/bankList.json';
import enMyDeletionRequests from './locales/en/myDeletionRequests.json';

import mlCommon from './locales/ml/common.json';
import mlLogin from './locales/ml/login.json';
import mlProfile from './locales/ml/profile.json';
import mlHome from './locales/ml/home.json';
import mlDashboard from './locales/ml/dashboard.json';
import mlTimeline from './locales/ml/timeline.json';
import mlCreateOrg from './locales/ml/createOrganization.json';
import mlContributions from './locales/ml/contributions.json';
import mlContributionForm from './locales/ml/contributionForm.json';
import mlTransactions from './locales/ml/transactions.json';
import mlAddExpense from './locales/ml/addExpense.json';
import mlExpenses from './locales/ml/expenses.json';
import mlApproveExpense from './locales/ml/approveExpense.json';
import mlDeleteTransaction from './locales/ml/deleteTransaction.json';
import mlViewExpenses from './locales/ml/viewExpenses.json';
import mlNotifications from './locales/ml/notifications.json';
import mlReports from './locales/ml/reports.json';
import mlDashboards from './locales/ml/dashboards.json';
import mlAdmin from './locales/ml/admin.json';
import mlAddUser from './locales/ml/addUser.json';
import mlUserList from './locales/ml/userList.json';
import mlBankDetails from './locales/ml/bankDetails.json';
import mlBankList from './locales/ml/bankList.json';
import mlMyDeletionRequests from './locales/ml/myDeletionRequests.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        login: enLogin,
        profile: enProfile,
        home: enHome,
        dashboard: enDashboard,
        timeline: enTimeline,
        createOrganization: enCreateOrg,
        contributions: enContributions,
        contributionForm: enContributionForm,
        transactions: enTransactions,
        addExpense: enAddExpense,
        expenses: enExpenses,
        approveExpense: enApproveExpense,
        deleteTransaction: enDeleteTransaction,
        viewExpenses: enViewExpenses,
        notifications: enNotifications,
        reports: enReports,
        dashboards: enDashboards,
        admin: enAdmin,
        addUser: enAddUser,
        userList: enUserList,
        bankDetails: enBankDetails,
        bankList: enBankList,
        myDeletionRequests: enMyDeletionRequests,
      },
      ml: {
        common: mlCommon,
        login: mlLogin,
        profile: mlProfile,
        home: mlHome,
        dashboard: mlDashboard,
        timeline: mlTimeline,
        createOrganization: mlCreateOrg,
        contributions: mlContributions,
        contributionForm: mlContributionForm,
        transactions: mlTransactions,
        addExpense: mlAddExpense,
        expenses: mlExpenses,
        approveExpense: mlApproveExpense,
        deleteTransaction: mlDeleteTransaction,
        viewExpenses: mlViewExpenses,
        notifications: mlNotifications,
        reports: mlReports,
        dashboards: mlDashboards,
        admin: mlAdmin,
        addUser: mlAddUser,
        userList: mlUserList,
        bankDetails: mlBankDetails,
        bankList: mlBankList,
        myDeletionRequests: mlMyDeletionRequests,
      },
    },
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'zbookkeeping_language',
      caches: ['localStorage'],
    },
  });

// Persist every language change to localStorage so it survives page refreshes.
// The LanguageDetector cache should handle this, but being explicit avoids
// subtle version-specific issues.
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('zbookkeeping_language', lng);
});

// Allow changing language from outside React (e.g. on login/profile load)
export const setI18nLanguage = (lng) => {
  if (lng && i18n.language !== lng) {
    i18n.changeLanguage(lng);
  }
};

export default i18n;
